/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-upload.vue?vue&type=template&id=64bee5a3&scoped=true"
import script from "./j-upload.vue?vue&type=script&lang=js"
export * from "./j-upload.vue?vue&type=script&lang=js"
import style0 from "./j-upload.vue?vue&type=style&index=0&id=64bee5a3&prod&lang=scss&scoped=true"
import style1 from "./j-upload.vue?vue&type=style&index=1&id=64bee5a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bee5a3",
  null
  
)

export default component.exports
import QMenu from 'quasar/src/components/menu/QMenu.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QMenu});qInstall(component, 'directives', {ClosePopup});
